<template>
  <div class="user-wrp-comments" style="margin-top: 40px;">

    <div class="user__list-offer">
      <div class="user__list-offer__item" v-for="msg in messages" :key="msg.id" style="background-color: white">
        <div class="user__list-comment-wrp">
          <div class="user__list__dorm">

            <div class="user__list__dorm-wrp">
              <p class="user__list__dorm-name" style="color:#23daa9">{{ msg.name }}</p>

              <div class="user__list__dorm-gen">
                <span class="user__list__dorm-location">
                 <svg-icon class="user__list__dorm-location-svg" type="icon-envelope-box"/>
                {{ msg.mail }}</span>

                <span class="user__list__dorm-location">
                 <svg-icon class="user__list__dorm-location-svg" type="icon-phone-classic"/>
                {{ msg.tel }}</span>
              </div>

            </div>
          </div>

          <div class="right-bar">
            <p class="user__list-date"> {{ msg.date }}</p>
            <p class="user__list-date">
              <span class="user__list__dorm-hour">
                 <svg-icon class="user__list__dorm-hour-svg" type="icon-oclock"/>
              </span>
              {{ msg.hour }}
            </p>
          </div>
        </div>

        <div class="user__list-comment" style="padding: 0px 2px;">
          <div class="user__list-link">
            <div class="user__list-bottom">
              Şube :
              <p class="user__list-bottom-title">
                <span class="location-ico">
               <svg-icon type="icon-location"/>
            </span>{{ msg.location }}
              </p>

            </div>

            <div class="user__list-message">
              {{ msg.text }}
            </div>

          </div>
        </div>

      </div>
      <MessageComment/>
    </div>

  </div>
</template>

<script>
import MessageComment from '@/components/MessageComment'
export default {
  components: {
    MessageComment
  },
  name: 'Offers',
  data () {
    return {
      messages: [
        {
          id: 0,
          date: '18 Mart 2018',
          logo: require('@/assets/img/campuscity-logo.png'),
          name: 'Sema AK',
          location: 'Republika Acedemic Apart Büyükçekmece',
          mail: '@aksema@outlook.com.tr',
          tel: '0539 596 69 76',
          hour: '18:15',
          text: 'Aşağıda, devlet ve vakıf üniversitelerine ait güncel 2018-2019 Güz Dönemi Yüksek Lisans ve Doktora İlanlarına ulaşabilirsiniz. Başvuru yapacak lisansüstü öğrenim adayları bağlantılara tıklayarak ilgili ilanlara ulaşabilir ve detaylı bilgi edinebilirler. Başvuru yapmadan önce ilanlarda belirtilen koşulları sağladığınızdan ve evrakları eksiksiz olarak.sa'
        }
      ]
    }
  }

}
</script>

<style lang="scss">
  @import "../assets/scss/components/messages";
</style>
